import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { AcompanhamentoDocumentoDepr } from "src/app/model/acompanhamento-documento-depr.model";
import { EntradaAcompanhamentoDocumentoDeprDTO } from "src/app/model/entrada-acompanhamento-documento-depr";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

@Injectable({
  providedIn: "root",
})
export class AcompanhamentoDeprService extends FgiBackEndService<AcompanhamentoDocumentoDepr> {
  getNewEntity(): AcompanhamentoDocumentoDepr {
    return null;
  }

  protected getResourceURL(): string {
    return "front/acompanhamento-documento-depr";
  }

  salvar(entradaDto: EntradaAcompanhamentoDocumentoDeprDTO): Observable<AcompanhamentoDocumentoDepr> {
    return this.http.post<AcompanhamentoDocumentoDepr>(this.BASE_URL, entradaDto);
  }

  public enviaDocumento(ideAcompanhamentoDepr: number, anexo: File): Observable<Object> {
    var formData =  new FormData();
    formData.append("arquivo", anexo);
    return this.http.post(`${this.BASE_URL}/${ideAcompanhamentoDepr}/arquivo`, formData);
  }

  getAcompanhamentos(params?: any):any{
    let options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<AcompanhamentoDocumentoDepr>>;
  }

  getAcompanhamentoDepr(id: number):any{
    let options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}`, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<Array<AcompanhamentoDocumentoDepr>>;
  }

  getArquivo(ideAcompanhamentoDepr: number) {
    return this.http.get(`${this.BASE_URL}/arquivo/${ideAcompanhamentoDepr}`, { responseType: 'blob' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public validar(acompanhamentoDepr: AcompanhamentoDocumentoDepr): any {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/validar`, acompanhamentoDepr, options);
  }

  public rejeitar(acompanhamentoDepr: AcompanhamentoDocumentoDepr): any {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/rejeitar`, acompanhamentoDepr, options);
  }
}
